import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useEffect } from 'react';
import { Typography, Button, TextInput, StackView, Box, Card, Responsive } from '@telus-uds/components-web';
export var CommunitySearch = function (_a) {
    var content = _a.content, lang = _a.lang, analytics = _a.analytics;
    var topText = content.topText, bottomText = content.bottomText, cta = content.cta, placeholder = content.placeholder;
    var _b = analytics !== null && analytics !== void 0 ? analytics : {}, eventActionTrigger = _b.eventActionTrigger, details = _b.details, name = _b.name;
    var searchInputRef = useRef(null);
    var getAnalyticsData = function () {
        var _a;
        var analyticsSearchTerm = (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.value.split(' ').slice(0, 7).join(' ');
        return {
            name: "KM_".concat(name === null || name === void 0 ? void 0 : name.pageName, "_CommunitySubmit").concat(analyticsSearchTerm ? "_".concat(analyticsSearchTerm) : '', "_").concat(name === null || name === void 0 ? void 0 : name.suffix),
            action: 'click',
            details: details
        };
    };
    var getSearchUrl = function () {
        var _a;
        if ((_a = searchInputRef === null || searchInputRef === void 0 ? void 0 : searchInputRef.current) === null || _a === void 0 ? void 0 : _a.value) {
            return lang === 'fr'
                ? encodeURI("https://communaute.koodomobile.com/search?q=".concat(searchInputRef.current.value))
                : encodeURI("https://community.koodomobile.com/search?q=".concat(searchInputRef.current.value));
        }
        return '#?';
    };
    var handleOnClick = function () {
        window.location.href = getSearchUrl();
        var analyticsData = getAnalyticsData();
        analyticsData && (eventActionTrigger === null || eventActionTrigger === void 0 ? void 0 : eventActionTrigger(analyticsData));
    };
    var handleKeyDown = function (e) {
        if (e.key === 'Enter') {
            window.location.href = getSearchUrl();
            var analyticsData = getAnalyticsData();
            analyticsData && (eventActionTrigger === null || eventActionTrigger === void 0 ? void 0 : eventActionTrigger(analyticsData));
        }
    };
    useEffect(function () {
        if (searchInputRef === null || searchInputRef === void 0 ? void 0 : searchInputRef.current)
            searchInputRef.current.addEventListener('keydown', function (e) { return handleKeyDown(e); });
        return function () {
            if (searchInputRef === null || searchInputRef === void 0 ? void 0 : searchInputRef.current)
                searchInputRef.current.removeEventListener('keydown', handleKeyDown);
        };
    }, [searchInputRef]);
    var container = (_jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsx(Typography, { block: true, heading: "h3", variant: { size: 'h3' }, children: topText }), _jsx(Typography, { block: true, heading: "h3", variant: { size: 'h3' }, children: bottomText })] }), _jsx(Box, { space: 0, flex: 1, children: _jsx(TextInput, { initialValue: placeholder, ref: searchInputRef }) }), _jsx(Button, { variant: { width: 'responsive' }, onPress: handleOnClick, children: cta !== null && cta !== void 0 ? cta : 'Submit' })] }));
    return (_jsxs(Card, { variant: { background: 'grid', padding: 'custom' }, tokens: {
            paddingBottom: 24,
            paddingLeft: 24,
            paddingRight: 24,
            paddingTop: 24
        }, children: [_jsx(Responsive, { min: "xs", max: "sm", children: _jsx(StackView, { direction: 'column', space: 3, children: container }) }), _jsx(Responsive, { min: "md", children: _jsx(StackView, { direction: 'row', space: 5, tokens: { alignItems: 'center' }, children: container }) })] }));
};
